import React from 'react';

type FeaturedImageProps = {
  imageURL: string;
};

const FeaturedImage: React.FC<FeaturedImageProps> = ({ imageURL }) => {
  if (!imageURL) return null;

  return (
    <img
        alt=''
        className='w-full h-auto border-2 border-black rounded-lg'
        src={ imageURL ? `${imageURL}` : require('../../assets/images/home_1.webp')}
        loading='lazy'
        srcSet={`${imageURL} 1200w, ${imageURL} 800w, ${imageURL} 400w`}
        sizes='(max-width: 600px) 400px,
                (max-width: 900px) 800px,
                1200px'
        style={{
            width: '100%',
            height: '300px',    // 👈 Limita el alto (podés ajustar este valor)
            objectFit: 'cover',
            objectPosition: 'center top'  // O 'center center', según prefieras
        }}
        />
  );
};

export default FeaturedImage;
